import axios from 'axios'

import former from './former'

export default {

    mixins: [
        former
    ],

    data () {
        return {
            fetcher: {
                fetchOnCreated: true,
                loading: true,
                initialized: false,
                autoFill: []
            }
        }
    },

    created () {
        if (this.fetcher.fetchOnCreated) {
            this.fetcherFetch()
        }
    },

    computed: {
        fetcherUrl () {
            return ''
        },
        fetcherParams () {
            return {}
        }
    },

    methods: {
        fetcherFetch () {
            this.fetcher.loading = true

            axios.get(this.fetcherUrl, this.fetcherParams)
                .then(response => {
                    this.fetcher.autoFill.forEach(key => {
                        this.$data[key] = response.data[key]
                    })

                    this.fetcher.loading = false
                    this.fetcher.initialized = true

                    this.fetcherSuccess(response.data)
                })
                .catch(error => {
                    console.log(error)

                    this.fetcher.loading = false
                })
        },

        fetcherSuccess (data) {

        }
    }
}
